import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthProvider } from '../../utils/auth';
import { AppRoutes } from '../../constants/routes';

/**
 * Route guard that requires authentication
 * Redirects unauthenticated users to login
 */
const AuthenticatedRoute = ({ children }) => {
  const { isAuthed, isLoading } = useAuthProvider();
  const location = useLocation();

  // Show loading while checking auth status
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        color: 'white'
      }}>
        Loading...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthed) {
    return <Navigate to={AppRoutes.LoginPage} state={{ from: location }} replace />;
  }

  // Allow access for authenticated users
  return children;
};

export default AuthenticatedRoute;
